import {
  KEEPER_SYNC_STARTED,
  KEEPER_SYNC_STATUS_UPDATED,
  KEEPER_SYNC_COMPLETE,
  KEEPER_SYNC_ERROR,
  KEEPER_SYNC_RESET,
  KEEPER_RECON_LOADING,
  KEEPER_RECON_REPORT_LOADED,
  KEEPER_RECON_REPORT_FAILED,
  KEEPER_RECON_EXECUTING,
  KEEPER_RECON_EXECUTED,
  KEEPER_RECON_EXECUTE_FAILED,
  KEEPER_RECON_ROW_UPDATING,
  KEEPER_RECON_ROW_UPDATED,
  KEEPER_RECON_ROW_UPDATE_FAILED,
  KEEPER_RECON_ROW_APPROVED,
  KEEPER_RECON_ROW_RESOLVED,
  KEEPER_RECON_COMPANIES_LOADED,
  KEEPER_RECON_UNMAPPED_LOADED,
  KEEPER_RECON_MAPPINGS_LOADED,
} from '../components/actions/keeperReconTypes'

const initialState = {
  // Sync state
  syncId: null,
  syncStatus: null,
  prompt: null,
  ssoLoginUrl: null,
  progress: null,
  syncError: null,
  syncCompanies: null,
  syncLoading: false,

  // Dashboard state
  loading: true,
  report: null,
  lastSyncDate: null,
  executing: false,
  updatingRowId: null,
  companyLabels: [],
  unmappedCompanies: [],
  mappings: [],
}

const keeperReconReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─── Sync ──────────────────────────────────
    case KEEPER_SYNC_STARTED:
      state.syncId = action.payload.syncId
      state.syncStatus = action.payload.status
      state.prompt = action.payload.prompt
      state.ssoLoginUrl = action.payload.ssoLoginUrl
      state.progress = null
      state.syncError = null
      state.syncCompanies = null
      state.syncLoading = action.payload.status !== 'awaiting_sso'
      return state

    case KEEPER_SYNC_STATUS_UPDATED:
      state.syncId = action.payload.syncId
      state.syncStatus = action.payload.status
      state.prompt = action.payload.prompt
      state.ssoLoginUrl = action.payload.ssoLoginUrl
      state.progress = action.payload.progress
      state.syncError = action.payload.error
      state.syncLoading =
        action.payload.status !== 'complete' &&
        action.payload.status !== 'error' &&
        action.payload.status !== 'awaiting_sso' &&
        action.payload.status !== 'awaiting_2fa'
      return state

    case KEEPER_SYNC_COMPLETE:
      state.syncStatus = 'complete'
      state.syncCompanies = action.payload.companies
      state.syncLoading = false
      state.syncError = null
      return state

    case KEEPER_SYNC_ERROR:
      state.syncStatus = 'error'
      state.syncError = action.payload
      state.syncLoading = false
      return state

    case KEEPER_SYNC_RESET:
      state.syncId = null
      state.syncStatus = null
      state.prompt = null
      state.ssoLoginUrl = null
      state.progress = null
      state.syncError = null
      state.syncCompanies = null
      state.syncLoading = false
      return state

    // ─── Dashboard ─────────────────────────────
    case KEEPER_RECON_LOADING:
      state.loading = true
      return state

    case KEEPER_RECON_REPORT_LOADED:
      state.loading = false
      state.report = action.payload.rows
      state.lastSyncDate = action.payload.lastSyncDate
      return state

    case KEEPER_RECON_REPORT_FAILED:
      state.loading = false
      return state

    case KEEPER_RECON_EXECUTING:
      state.executing = true
      return state

    case KEEPER_RECON_EXECUTED:
      state.executing = false
      return state

    case KEEPER_RECON_EXECUTE_FAILED:
      state.executing = false
      return state

    case KEEPER_RECON_ROW_UPDATING:
      state.updatingRowId = action.payload
      return state

    case KEEPER_RECON_ROW_UPDATED:
      state.updatingRowId = null
      return state

    case KEEPER_RECON_ROW_UPDATE_FAILED:
      state.updatingRowId = null
      return state

    case KEEPER_RECON_ROW_APPROVED:
      state.updatingRowId = null
      if (state.report) {
        state.report = state.report.map((r) =>
          r.companyId === action.payload
            ? { ...r, status: 'Approved', statusReason: null }
            : r
        )
      }
      return state

    case KEEPER_RECON_ROW_RESOLVED:
      state.updatingRowId = null
      if (state.report) {
        state.report = state.report.map((r) =>
          r.companyId === action.payload
            ? { ...r, status: 'Pending', statusReason: null }
            : r
        )
      }
      return state

    case KEEPER_RECON_COMPANIES_LOADED:
      state.companyLabels = action.payload
      return state

    case KEEPER_RECON_UNMAPPED_LOADED:
      state.unmappedCompanies = action.payload
      return state

    case KEEPER_RECON_MAPPINGS_LOADED:
      state.mappings = action.payload
      return state

    default:
      return state
  }
}

export default keeperReconReducer
